'use client';
import { useEffect, useState } from 'react';
import { usePathname, useRouter } from 'next/navigation';
import { toast } from 'sonner';
import { useEnabledModules } from '@/hooks/use-enabled-modules';

// Longest prefixes first so '/settings/portal/manager' is tested before '/settings/portal'.
const ROUTE_MODULE: Array<[string, string]> = [
  ['/settings/portal/manager', 'team-portal'],
  ['/settings/integrations', 'integrations'],
  ['/settings/portal', 'user-portal'],
  ['/phishtrainer', 'phishtrainer'],
  ['/announcements', 'announcements'],
  ['/jit-training', 'jit-training'],
  ['/gamification', 'gamification'],
  ['/esa', 'esa'],
  ['/phishing', 'phishing'],
  ['/reports', 'reports'],
  ['/lms', 'lms'],
];

export function ModuleAccessGuard({ children }: { children: React.ReactNode }) {
  const pathname = usePathname();
  const router = useRouter();
  const enabled = useEnabledModules(); // Set<string> | null
  const [mounted, setMounted] = useState(false);
  // legitimate external sync: SSR-hydration signal to avoid redirect before first client render
  /* eslint-disable react-hooks/set-state-in-effect */
  useEffect(() => setMounted(true), []);
  /* eslint-enable react-hooks/set-state-in-effect */

  useEffect(() => {
    if (!mounted || enabled === null) return; // fail-open: don't redirect while loading/unknown
    const hit = ROUTE_MODULE.find(
      ([prefix]) => pathname === prefix || pathname.startsWith(prefix + '/'),
    );
    if (hit && !enabled.has(hit[1])) {
      toast.error("This module isn't enabled for your workspace.");
      router.replace('/');
    }
  }, [mounted, pathname, enabled, router]);

  return <>{children}</>;
}
